export default {
    data: function() {
      return {
          studentParticular: {
            ethnicity: "",
            certificateNo:'',
            spokenLanguageAtHome: "",
            certificateNoTop: "",
            certificateNoCont: "",
            certificateNoBottom: "",
            englishName: "",
            chineseName: "",
            gender: 0,
            dateOfBirth: "",
            placeOfBirthInput:'',
            placeOfBirth: "",
            nationality: "",
            typeOfIdentityDocument: {
              type: 0,
              certificateNo: "",
              passportNo: "",
              country: "",
            },
            contactNo: "",
            address: {
              flat: "",
              floor: "",
              block: "",
              building: "",
              village: "",
              street: "",
              district: "",
              area: "",
            },
            addressEn: {
              flat: "",
              floor: "",
              block: "",
              building: "",
              village: "",
              street: "",
              district: "",
              area: "",
            },
            correspondenceAddress: {
              flat: "",
              floor: "",
              block: "",
              building: "",
              village: "",
              street: "",
              district: "",
              area: "",
            },
            religion: "",
            newArrivalToHk: {
              isNew: false,
              placeOfOrign: "",
              arrivalDate: "",
            },
            applicantPreviouslyApplied: {
              isHas: false,
              level: "",
              year: "",
            },
            siblingsAtLogosAcademy: {
              isHas: false,
              siblings: [
                {
                  name: "",
                  class: "",
                  year: "",
                },
              ],
            },
            siblingsIdentityDocument: {
              isHas: false,
              siblings: [],
            },
            levelApplyingFor: null,
            recommendedSchoolBoard:{
              isHas: false,
              recommenderName: '',
              recommenderContactMethod:'',
              relationshipWithTheStudent:'',
              recommenderLastAttendedClass:'',
              recommenderStudentId:'',
              recommenderGraduationYear:'',
              relationshipWitheOurSchool:''
            },
            recommendedCurrentStaff:{
              isHas: false,
              recommenderName: '',
              recommenderContactMethod:'',
              relationshipWithTheStudent:'',
              recommenderLastAttendedClass:'',
              recommenderStudentId:'',
              recommenderGraduationYear:'',
              relationshipWitheOurSchool:''
            },
            recommendedChildAlumnus:{
              isHas: false,
              recommenderName: '',
              recommenderContactMethod:'',
              relationshipWithTheStudent:'',
              recommenderLastAttendedClass:'',
              recommenderStudentId:'',
              recommenderGraduationYear:'',
              relationshipWitheOurSchool:''
            },
            recommendedOthers:{
              isHas: false,
              recommenderName: '',
              recommenderContactMethod:'',
              relationshipWithTheStudent:'',
              recommenderLastAttendedClass:'',
              recommenderStudentId:'',
              recommenderGraduationYear:'',
              relationshipWitheOurSchool:'',
            },
          },
          parentParticularData: {
            parentParticulars: [
              {
                type: 0,
                chineseName: "",
                englishName: "",
                occupation: "",
                organization: "",
                mobile: "",
                email: "",
                officeTel: "",
                isMainGuardian: false,
              },
              {
                type: 1,
                chineseName: "",
                englishName: "",
                occupation: "",
                organization: "",
                mobile: "",
                email: "",
                officeTel: "",
                isMainGuardian: false,
              },
              {
                type: 2,
                chineseName: "",
                englishName: "",
                occupation: "",
                organization: "",
                mobile: "",
                email: "",
                officeTel: "",
                isMainGuardian: false,
              },
            ],
          },
          studentPerformance:{
            studentPerformances:[
                {
                      level: '',
                      terms: [
                        {
                          chineseLanguage: "",
                          englishLanguage: "",
                          mathematics: "",
                          conduct: "",
                          levelTitle:'Term 1',
                        },
                        {
                          chineseLanguage: "",
                          englishLanguage: "",
                          mathematics: "",
                          conduct: "",
                          levelTitle:'Term 2',
                        },
                        {
                          chineseLanguage: "",
                          englishLanguage: "",
                          mathematics: "",
                          conduct: "",
                          levelTitle:'Term 3 (if applicable)',
                        },
                        {
                          chineseLanguage: "",
                          englishLanguage: "",
                          mathematics: "",
                          conduct: "",
                          levelTitle:'Term 4 (if applicable)',
                        },
                        {
                          chineseLanguage: "",
                          englishLanguage: "",
                          mathematics: "",
                          conduct: "",
                          levelTitle:'Overall (if applicable)',
                        },
          
                      ]
                },
                {
                    level: '',
                    terms: [
                      {
                        chineseLanguage: "",
                        englishLanguage: "",
                        mathematics: "",
                        conduct: "",
                        levelTitle:'Term 1',
                      },
                      {
                        chineseLanguage: "",
                        englishLanguage: "",
                        mathematics: "",
                        conduct: "",
                        levelTitle:'Term 2',
                      },
                      {
                        chineseLanguage: "",
                        englishLanguage: "",
                        mathematics: "",
                        conduct: "",
                        levelTitle:'Term 3 (if applicable)',
                      },
                      {
                        chineseLanguage: "",
                        englishLanguage: "",
                        mathematics: "",
                        conduct: "",
                        levelTitle:'Term 4 (if applicable)',
                      },
                      {
                        chineseLanguage: "",
                        englishLanguage: "",
                        mathematics: "",
                        conduct: "",
                        levelTitle:'Overall (if applicable)',
                      },
        
                    ]
                },
                {
                  level: '',
                  terms: [
                    {
                      chineseLanguage: "",
                      englishLanguage: "",
                      mathematics: "",
                      conduct: "",
                      levelTitle:'Term 1',
                    },
                    {
                      chineseLanguage: "",
                      englishLanguage: "",
                      mathematics: "",
                      conduct: "",
                      levelTitle:'Term 2',
                    },
                    {
                      chineseLanguage: "",
                      englishLanguage: "",
                      mathematics: "",
                      conduct: "",
                      levelTitle:'Term 3 (if applicable)',
                    },
                    {
                      chineseLanguage: "",
                      englishLanguage: "",
                      mathematics: "",
                      conduct: "",
                      levelTitle:'Term 4 (if applicable)',
                    },
                    {
                      chineseLanguage: "",
                      englishLanguage: "",
                      mathematics: "",
                      conduct: "",
                      levelTitle:'Overall (if applicable)',
                    },

                  ]
                }
            ]
          },
          personalBackground: {
            currentSchoolInformation: {
              schoolName: "",
              schoolAddress: "",
              schoolContactNumber: "",
              schoolEmail: "",
              dateJoined: "",
              currentAttendedYearLevel: "",
              isTheApplicantAttendingTheSchool: "",
            },
            previousSchoolInformation: [
              {
                schoolName: "",
                class: "",
                mainMediumOfInstruction: "",
                startDate: "",
                endDate: "",
              },
            ],
          },
          studentFiles: [
            {
              type: 0,
              path: "",
            },
            {
              type: 1,
              path: "",
            },
            {
              type: 2,
              path: "",
            },
            {
              type: 3,
              path: "",
            },
            {
              type: 4,
              path: "",
            },
            {
              type: 5,
              path: "",
            },
            {
              type: 6,
              path: "",
            },
          ],
          declaration: {
            isReadStatement: false,
          },
          questionnaire: {
            questionnaires: [
              {
                question:
                  "申請人是否對音樂、體育或其他方面有濃厚興趣或才能?\nDoes the applicant have strong interests or talents in music, sports, etc? ",
                answer: "",
              },
              {
                question:
                  "申請人是否在社會服務或社區工作上有任何經驗?\nDoes the applicant have any experience of social service or community work?  ",
                answer: "",
              },
              {
                question:
                  "請形容申請人三個性格上的優點。\nGive three features that best describe the applicant’s character. ",
                answer: "",
              },
              {
                question:
                  "申請人期望在本校就讀香港中學文憑課程學到甚麼? \nWhat does the applicant expect to learn from our school during the study of the HKDSE Programme?  ",
                answer: "",
              },
              {
                question:
                  "申請人是否有特殊教育需要? 如有，請說明。\nDoes the applicant have any special educational needs? If yes, please specify.  ",
                answer: "",
              },
              {
                question:
                  "申請人理想的職業是甚麼? \nWhat is the applicant’s ideal career aspiration? ",
                answer: "",
              },
              {
                question:
                  "如有任何其他資料補充，請在此填寫。\nGive any other information or comments which may be useful.",
                answer: "",
              },
            ],
          },
          applicantLanguage: {
            applicantLanguages: [
              {
                type: 0,
                LanguageType: 0,
                language:null
              },
              {
                type: 1,
                LanguageType: 0,
                language:null
              },
              {
                type: 2,
                LanguageType: 0,
                language:null
              },
            ],
          },
          subjectsApplied: {
            eletives: [],
            core: [],
            otherSubjects: [
              {
                groupType: 0,
                subject: "Chinese Language A: Language and Literature",
                isSelectedStandardLevel: true,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 1,
                subject: "English B",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: true,
              },
              {
                groupType: 2,
                subject: "Economics",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 2,
                subject: "Geography",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 2,
                subject: "History",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 2,
                subject: "Psychology",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 3,
                subject: "Biology",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 3,
                subject: "Chemistry",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 3,
                subject: "Computer Science",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 3,
                subject: "Physics",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 4,
                subject: "Mathematics : Analysis and Approaches",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 5,
                subject: "Music",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
              {
                groupType: 5,
                subject: "Visual Arts",
                isSelectedStandardLevel: false,
                isSelectedHigherLevel: false,
              },
            ],
          },
      };
    },
}